function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#5B6670;}\n\t.st1{fill:#00B2E3;}\n");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M73.1,321.4h26.1v19.1c-7.2,5.1-15.8,7.8-24.6,7.7c-20.9,0-34.7-15.4-34.7-36.5v-0.3c0-19.5,14.3-36,33.1-36 c10.7-0.3,21,3.6,28.7,10.9l11.3-13.6c-10.5-8.9-21.4-13.9-39.3-13.9c-28.7-0.3-52.3,22.7-52.7,51.4c0,0.5,0,0.9,0,1.4v0.3 c0,29.8,21,52.5,52.9,52.5c15.7,0,30.8-5.7,42.6-16v-42.8H73.1V321.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M157.2,284.8c-10.1-0.2-20.2,2-29.3,6.4l4.9,14.2c6.9-3.1,14.4-4.8,22-4.8c12.3,0,19,5.8,19,16.5v1.4 c-6.9-2.2-14.1-3.3-21.3-3.2c-17.9,0-31.2,8.2-31.2,25.2v0.3c0,15.5,12.8,23.8,27.4,23.8c9.6,0.3,18.8-3.7,25-11.1v9.6h17.5v-45.8 C191.1,296.7,180,284.8,157.2,284.8 M174,335.1c0,9.6-8.8,16.2-20.4,16.2c-8.3,0-14.9-4.1-14.9-11.4v-0.3c0-7.4,6.6-12,17.6-12 c6,0,12,1.1,17.7,3.2V335.1z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 201,
  y: 286,
  className: "st0",
  width: 17.6,
  height: 77
}), /*#__PURE__*/React.createElement("rect", {
  x: 200.2,
  y: 257.5,
  className: "st0",
  width: 19,
  height: 16.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M246.9,319.6c0-12,7.1-19.1,17.4-19.1s16.5,6.9,16.5,18.8v43.8h17.6v-49c0-17.9-10.1-29.6-27.4-29.6 c-9.9-0.1-19,5.1-24.1,13.6v-12h-17.6v77h17.6V319.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M334.1,350.6c-9.2-0.4-18.1-3.8-25.2-9.6l-7.9,12c9.4,7.4,20.9,11.4,32.8,11.6c16,0,28.7-8,28.7-24.2v-0.3 c0-13.9-12.8-19-23.9-22.3c-9.3-3-17.6-5.4-17.6-10.9v-0.3c0-4.5,3.9-7.8,10.8-7.8c7.8,0.5,15.2,3,21.7,7.3l7-12.5 c-8.4-5.5-18.2-8.6-28.3-8.8c-15.3,0-27.4,8.9-27.4,23.5v0.3c0,14.7,12.8,19.4,24.1,22.6c9.1,2.8,17.2,4.8,17.2,10.8v0.3 C346.1,347.4,341.7,350.6,334.1,350.6"
}), /*#__PURE__*/React.createElement("rect", {
  x: 366.6,
  y: 257.2,
  className: "st0",
  width: 19,
  height: 16.8
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "367.3,286 367.3,363.1 374.3,363.1 385,363.1 385,358.8 385,286  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M452.9,297.3c-6.4-8.4-16.4-13.3-27-13.1c-17.6-0.3-32.5,12.8-34.7,30.2c-0.3,2-0.4,4-0.4,6v0.3 c-0.4,11.4,4.9,22.4,14,29.2c1.2,0.8,2.4,1.6,3.7,2.3l0.9,0.5l27.4-11.8c-1,0.3-2.1,0.5-3.2,0.7c-1.1,0.1-2.1,0.2-3.2,0.2h-1.6 c-1-0.1-2-0.2-3-0.4c-4.2-0.7-8.1-2.7-11.1-5.7c-1.2-1.3-2.3-2.7-3.2-4.2c-0.3-0.5-0.5-1-0.8-1.5c-0.8-1.6-1.3-3.3-1.6-5.1 c0-0.2,0-0.4,0-0.6c-0.2-1.2-0.3-2.5-0.3-3.7v-0.4c0-1.5,0.1-3,0.4-4.5c0-0.4,0.2-0.9,0.3-1.3c0.3-1,0.6-1.9,1-2.8 c0.5-1.3,1.2-2.5,2-3.6c1.6-2.2,3.6-4.1,5.9-5.6c3.7-2.2,8-3.3,12.3-3.2c4.2,0,8.3,1.1,11.9,3.2l1.3,0.8c0.9,0.6,1.8,1.3,2.7,2 c1.5,1.4,2.9,3,3.9,4.9c0.4,0.6,0.7,1.2,1,1.9c0.4,0.9,0.7,1.8,1,2.7c0.5,1.9,0.8,4,0.8,6v0.3c0,1.8-0.3,3.6-0.7,5.4 c-0.5,2-1.4,3.9-2.5,5.6c-0.3,0.5-0.6,1-1,1.4c-0.7,0.9-1.5,1.7-2.3,2.5l-1.3,1.1c-0.4,0.3-0.7,0.6-1.1,0.9l-1,0.6l27.2-12v-40.8 h-17.6V297.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M498.2,314.1c0.2-0.8,0.4-1.7,0.7-2.5c1-3.4,3.2-6.3,6.1-8.4c1.4-1,3-1.8,4.6-2.2c1.8-0.5,3.6-0.8,5.5-0.8 c0.7,0,1.5,0,2.2,0c1.3,0.1,2.6,0.4,3.9,0.9c0.6,0.2,1.2,0.5,1.8,0.7c0.6,0.3,1.2,0.6,1.8,1c0.1,0.1,0.2,0.2,0.3,0.3l19.1-8.2 v-0.2c-0.3-0.4-0.5-0.8-0.8-1.1c-5.2-6.4-13.2-10-21.4-9.6c-10-0.1-19.2,5.2-24.2,13.8v-41.5H480v66.2l18.1-7.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "575,264.6 557.4,264.6 557.4,287.7 557.4,288.8 575,281.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M440.4,339.8c-1.1,0.5-2.3,0.9-3.4,1.2l-27.4,11.8c5.1,2.6,10.7,4,16.3,4c10.9,0.1,21.1-5.2,27.2-14.2v6 c0.2,5.2-1.1,10.3-3.9,14.7c-4,5.9-10.9,8.9-20.5,8.9c-9.7,0-19.3-2.8-27.4-8.2l-6.6,13.3c10.4,6.1,22.3,9.3,34.4,9.2 c13.9,0,24.6-3.4,31.7-10.4c3.5-3.6,6.1-8,7.5-12.8c1.6-5.2,2.3-10.7,2.2-16.2v-20.6l-27.3,11.7 C442.3,338.8,441.4,339.3,440.4,339.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M524.9,303.3c3.5,2.7,5.7,6.8,6.2,11.2c0.2,1.5,0.4,3.1,0.4,4.7v43.8h17.6v-49.1c0.2-6.6-1.6-13.2-5.1-18.8 L524.9,303.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M480,362.8h17.6v-43.5c0-1.5,0.1-3.1,0.4-4.6l-18.1,7.8V362.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M621,263.9v-1.8l0,0l0,0l-37.4,15.6l-26.2,11v52.8c0,13.2,5.6,19.6,14.3,21.7c2.6,0.6,5.2,0.9,7.9,0.9 c2.7,0,5.5-0.3,8.1-0.9c2.7-0.7,5.3-1.7,7.8-3.2v-14.4c-3.4,1.8-7.1,2.7-10.9,2.6c-6,0-9.6-2.8-9.6-9.6v-38.3l45.9-19.1l0,0l0,0 L621,263.9z"
})));

const SvgGainsightCs = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "layer",
  x: "0px",
  y: "0px",
  viewBox: "0 0 652 652",
  style: {
    enableBackground: "new 0 0 652 652"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGainsightCs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gainsight_cs.84a1ca7c.svg";
export { ForwardRef as ReactComponent };